export const VideoWrapper = ({ children }) => {
  return <div className="wrapper">{children}</div>;
};
